import {GridActionsCellItem} from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import Typography from "@mui/material/Typography";
import thousandSeparator from "../../utils/numberUtils";
import {Avatar, Stack} from "@mui/material";


const statusMap = {
    'accepted': 'elfogadott',
    'pending': 'elfogadásra vár...',
    'rejected': '',

}

const renderName = (params) => <Stack spacing={1} direction='row'>
    <Avatar className={params.row?.display_status}>{params.row?.last_name[0]}{params.row?.first_name[0]}</Avatar>
    <Stack spacing={0}>
        <span className='reservation-name'>{params.row?.name}</span>
        <span
            className={`reservation-${params.row?.display_status}`}>{params.row?.display_status !== 'rejected' && statusMap[params.row?.display_status]}</span>
    </Stack>
</Stack>

const renderDate = (params) => <Stack spacing={0}>
    <Typography variant='button' style={{color: '#000'}}
                align='left'>{params.row?.start_time}-{params.row?.end_time}</Typography>
    <Typography variant='caption' style={{color: '#536B74'}} align='left'>{params.row?.date}</Typography>
</Stack>


const getColumns = (onDeleteClicked, onDetailClicked) => [
    {field: 'name', headerName: 'Kliens neve', width: 200, renderCell: renderName},
    {
        field: 'service',
        headerName: 'Szolgáltatás',
        width: 200,
        renderCell: (params) => <Typography variant='button'>{params.row?.price?.service?.name}</Typography>,
        valueGetter: (params) => params.row?.price?.service?.name
    },
    {
        field: 'colleague',
        headerName: 'Kolléga',
        width: 130,
        renderCell: (params) => <Typography variant='caption'
                                            style={{color: '#536B74'}}>{params.row?.price?.colleague?.name}</Typography>,
        valueGetter: (params) => params.row?.price?.colleague?.name
    },
    {
        field: 'date',
        headerName: 'Időpont',
        type: 'dateTime',
        width: 130,
        renderCell: renderDate,
        valueGetter: (params) => `${params.row?.date} ${params.row?.start_time}`
    },
    {
        field: 'price',
        headerName: 'Ár',
        width: 130,
        type: 'number',
        renderCell: (params) => <Typography variant='button'
                                            style={{color: '#536B74'}}>{thousandSeparator(params.row?.price?.price) + ' Ft'}</Typography>,
        valueGetter: (params) => params.row?.price?.price
    },
    {
        field: 'manage',
        sortable: false,
        type: "actions",
        width: 200,
        // renderCell: params => <Stack direction='row'>
        //     <CircleButton icon={<DeleteIcon/>}/>
        //     <CircleButton icon={<DeleteIcon/>} inverted/>
        // </Stack>
        getActions: (params) => [
            <GridActionsCellItem
                icon={<DeleteIcon className='icon-style'/>}
                onClick={() => onDeleteClicked(params.row?.id)}
                label="Törlés"
                showInMenu={false}/>,
            <GridActionsCellItem
                icon={<KeyboardArrowRightRoundedIcon className='inverted-icon-style'/>}
                onClick={() => onDetailClicked(params.row?.id)}
                label="Részletek"
                showInMenu={false}/>]
    },
]

export {getColumns}